var render, staticRenderFns
import script from "./RemoteNewsroomItemList.vue?vue&type=script&lang=js&"
export * from "./RemoteNewsroomItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1ca1f12')) {
      api.createRecord('d1ca1f12', component.options)
    } else {
      api.reload('d1ca1f12', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Newsroom/Components/Remote/RemoteNewsroomItemList.vue"
export default component.exports